module.exports = ReactDOM19;